import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import UserComplianceStore from '../../stores/UserComplianceStore';
import DetailView from '../Common/DetailView';
import { listUserCompliances } from '../../actions/UserActionCreator';
import ComplianceSegment from '../Compliance/ComplianceSegment';
import IconPerson from 'material-ui/svg-icons/action/perm-identity';
import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import SettingsIcon from 'material-ui/svg-icons/action/settings';

const getMenuItems = (id) => [
    {
        link: `/dashboard/user/${id}`,
        icon: <IconPerson />,
        label: 'User profile',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/user/${id}/settings`,
        icon: <SettingsIcon />,
        label: 'Settings',
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

class UserComplianceList extends Component {
    componentDidMount() {
        listUserCompliances(this.props.userId)
    }

    render() {
        const actions = buildContextMenu((this.props.menuItems || getMenuItems(this.props.userId)), this.context.auth);

        return (
            <DetailView
                title="Compliance"
                actions={actions}
                backButton={this.context.auth.identity.id !== this.props.userId}
            >
                <div className="cent-cards">
                    {this.state.items.map(item => <ComplianceSegment key={item.complianceId} {...item} />)}
                </div>
            </DetailView>
        );
    }
}

UserComplianceList.getStores = () => ([UserComplianceStore]);
UserComplianceList.calculateState = (prevState, {userId}) => ({
    isFetching: UserComplianceStore.isFetching(),
    items: UserComplianceStore.getByUser(userId) || []
});

UserComplianceList.propTypes = {
    userId: PropTypes.number.isRequired
};

UserComplianceList.contextTypes = {
    auth: PropTypes.object
};

const UserComplianceContainer = Container.create(UserComplianceList, {withProps: true});
export default UserComplianceContainer;

